import { Component, ViewChild, TemplateRef, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
// -- components --
import { SubTabsComponent } from '../components/sub-tabs/sub-tabs.component';
import { Step1Component } from './components/step-1/step-1.component';
import { Step2Component } from './components/step-2/step-2.component';
import { Step3Component } from './components/step-3/step-3.component';
// -- models --
import { TabOption } from '../components/sub-tabs/sub-tabs.component';
import { Jc3Service } from '../jc3.service';

@Component({
    selector: 'app-jumpstart-guide',
    standalone: true,
    imports: [
        CommonModule,
        SubTabsComponent,
        Step1Component,
        Step2Component,
        Step3Component,
    ],
    templateUrl: './jumpstart-guide.component.html',
    styleUrl: './jumpstart-guide.component.scss',
})
export class JumpstartGuideComponent implements OnInit {
    tabs: TabOption[] = [];
    ga: any = {
        id: '',
        label: '',
        category: 'JC3 Button',
    };
    jsData: any = [];
    steps: any = [];
    step1data = {};
    step2data = {};
    step3data = {};

    constructor(private _jc3Service: Jc3Service) {}

    @ViewChild('step1') step1!: TemplateRef<any>;
    @ViewChild('step2') step2!: TemplateRef<any>;
    @ViewChild('step3') step3!: TemplateRef<any>;

    ngOnInit(): void {
        this.getJumpstartData();
        this.getSteps();
    }

    ngAfterViewInit() {
        this.toggleTab(this.tabs?.at(0)?.value);
    }

    getJumpstartData() {
        this._jc3Service.getJumpstartOverviewSwitcher().subscribe({
            next: (response) => {
                this.jsData = response?.at(0);
                this.tabs = [
                    {
                        label: this.jsData?.switcher1,
                        value: this.jsData?.switcher1group,
                        template: this.step1,
                    },
                    {
                        label: this.jsData?.switcher2,
                        value: this.jsData?.switcher2group,
                        template: this.step2,
                    },
                    {
                        label: this.jsData?.switcher3,
                        value: this.jsData?.switcher3group,
                        template: this.step3,
                    },
                ];

                this._jc3Service.getJumpstartSteps().subscribe({
                    next: (res) => {
                        this.step1data = res?.filter(
                            (item) =>
                                item.switcher1group === this.tabs.at(0).value
                        )[0];
                        this.step2data = res?.filter(
                            (item) =>
                                item.switcher1group === this.tabs.at(1).value
                        )[0];
                        this.step3data = res?.filter(
                            (item) =>
                                item.switcher1group === this.tabs.at(2).value
                        )[0];
                    },
                    error: (error) => {
                        console.error('Error fetching WhatsNew data:', error);
                    },
                });
            },
            error: (error) => {
                console.error('Error fetching WhatsNew data:', error);
            },
        });
    }
    getSteps() {}

    toggleTab(event: any) {
        const currTab = this.tabs.filter((item) => item.value === event)[0];
        const name = currTab?.label?.split('-')[0].trim();
        const slug = name?.toLowerCase().replaceAll(' ', '_');
        this.ga.label = name + ' Download Button Click';
        this.ga.id = slug + '_download_button_jc3_click';
    }
}
